import { MfaChallengeForm } from '@/features/identity/components/MfaChallengeForm';

export function MfaChallengePage() {
  return <MfaChallengeForm />;
}
